import EmpresasByAdminTemplate from "../components/templates/EmpresasByAdminTemplate";

const EmpresasByAdmin = () => {
    return <EmpresasByAdminTemplate/>;
};

export default EmpresasByAdmin;